export interface CabinetProperties {}

export module CabinetProperties {
  export const defaultValue: Readonly<CabinetProperties> = {};
}
